import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-blue-50 relative" data-id="element-179" data-mp="1jb1sug4wmy7r">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-180" data-mp="1n9r525e7i9pt">
        <div className="text-center mb-10" data-id="element-181" data-mp="1s9dfy86kbdvg">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-blue-950 uppercase" data-id="element-182" data-mp="1s82b051ds02r">
            Your Complete <span className="text-orange-500" data-id="element-183" data-mp="1x6nd6a070ttu">Dog Grooming Instructor Ready</span>{' '}
            Package
          </h2>
          <p className="text-slate-700 text-sm md:text-base" data-id="element-184" data-mp="2up3y81vvxxy">
            Everything You Need to Plan Less and Teach With More Structure
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-blue-950 border-2 border-orange-500 rounded-3xl p-1 relative shadow-xl shadow-blue-950/15" data-id="element-185" data-mp="7ubpr5vs2mid">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange-500 text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-186" data-mp="17rsatq2quipj">
            <Sparkles size={14} data-id="element-187" data-mp="20fxwqg5jadqy" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-188" data-mp="20emrebwfwxxq">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-xl h-auto mx-auto mb-6" loading="lazy" data-id="element-189" data-mp="1vfjlkp8mynop" />

            <p className="text-sm text-slate-700 max-w-md mx-auto mb-6" data-id="element-190" data-mp="k3r66s8ormfe">
              Dog Grooming Instructor Ready complete system: 6 professional volumes, 100% visual
              teaching material and 5 professional bonus guides.
            </p>

            <p className="text-sm font-bold tracking-widest text-blue-600 mb-3" data-id="element-191" data-mp="mgkvtvzqj692">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-amber-50 border border-amber-200/70 rounded-xl p-4" data-id="element-192" data-mp="7ju5sdbyb6w4">
              {packageIncludes.map((item, itemIndex) => <li key={item.label} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-193" data-mp="3uwo5266hx2zi" data-mpi={itemIndex}>
                  {itemIndex === 6 && <span className="sr-only" data-id="element-194" data-mp="3hqk6vvkilx4">Plus:</span>}
                  {item.kind === 'bonus' ? <Gift size={16} className="text-orange-500 shrink-0 mt-0.5" data-id="element-195" data-mp="3kz095cx5lpfr" /> : <Check size={16} className="text-blue-600 shrink-0 mt-0.5" data-id="element-196" data-mp="3pws0a4pz57iw" />}
                  <span data-id="element-197" data-mp="3bxjxl1ulrh9y">{item.label}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-198" data-mp="3fzx61y0qhtaf">
              <p className="text-sm text-slate-500 mb-1" data-id="element-199" data-mp="3fyvs9lsc2sp0">
                REGULAR VALUE: <span className="line-through" data-id="element-200" data-mp="2xc4px7gm1g1r">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-201" data-mp="2scjqkvxj35oi">
                <span className="text-2xl md:text-3xl text-slate-600" data-id="element-202" data-mp="36bru210q4zyi">TODAY:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-orange-500" data-id="element-203" data-mp="369ovgsli9yi6">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-204" data-mp="3g84hwi9l8jlc">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-205" data-mp="3l0xmn6523rxf">
              <span className="flex items-center gap-1.5" data-id="element-206" data-mp="2ut274r1k79h">
                <Lock size={12} className="text-blue-600" data-id="element-207" data-mp="2syiftrial6z" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-208" data-mp="3u36yq0fz3tcx">
                <Zap size={12} className="text-blue-600" data-id="element-209" data-mp="hyvvo8o9h6mm" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-210" data-mp="lyw8jovpp9rk">
                <Wallet size={12} className="text-blue-600" data-id="element-211" data-mp="lxbh484p26xx" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}